// extracted by mini-css-extract-plugin
export default {"title":"t--z","warning":"u--z","sizeOptionsLegendText":"v--z"};